<template>

<app-input class="select" :validation="validation" :class="{'has-value': value, 'is-expanded': isExpanded}" :label="label" :stacked="stacked" :no-line="noLine" :is-ready="value.length" :notes="notes" :disabled="disabled">

	<div class="select-value" v-on:click="onToggleClick">

		<template v-if="value">{{ optionText }}</template>
		<template v-if="!value">{{ placeholder }}</template>

		<app-icon icon="caret.down" class="select-value-icon" />
		
	</div>

	<div class="select-list" v-if="isExpanded">

		<div class="select-list-item" :class="{'is-divide': option.value === null, 'is-active': key === option.value || parseInt(key) === option.value}" v-for="(option, key) in options" :key="key" v-on:click="onOptionClick(option.value)">
			
			<div class="select-list-item-icon" v-if="option.icon"><app-icon :icon="option.icon" /></div>
			<div class="select-list-item-text" v-if="option.text">{{ option.text }}</div>
			
		</div>

	</div>
	
</app-input>

</template>

<script>

export default {

	props: ['validation', 'label', 'disabled', 'asString', 'value', 'icons', 'options', 'noLine', 'store', 'stacked', 'placeholder', 'notes'],

	data: function() {

		return {
			isExpanded: false
		}

	},

	computed: {

		optionText: function() {

			return this.$_.findWhere(this.options, {
				value: this.value
			}).text

		}

	},

	methods: {

		onToggleClick: function() {

			this.isExpanded = !this.isExpanded

		},

		onOptionClick: function(value) {

			console.log(value)
			
			this.isExpanded = false

			this.$emit('input', (this.asString) ? value : parseInt(value))

		}

	}

}

</script>

<style scoped>

.select-value {
	line-height: 36px;
	font-size: 16px;
	flex-grow: 1;
	padding: 0px 10px;
	color: #333;
	background-color: #fff;
	border-radius: 12px;
	border: 2px solid #eee;
	cursor: pointer;
}

.select-value:hover {
	border-color: #4082d3;
}

.select.is-expanded .select-value {
	border-color: #4082d3;
	border-radius: 12px 12px 0px 0px;
}

.select-value-icon {
	color: #999;
	position: absolute;
	right: 10px;
	font-size: 16px;
	top: 2px;
}

.select.is-expanded .select-value-icon,
.select-value:hover .select-value-icon {
	color: #4082d3;
}

.select-list {
	position: absolute;
	z-index: 2;
	left: 0px;
	padding: 10px 0px;
	width: 100%;
	background-color: #4082d3;
	border-radius: 0px 0px 12px 12px;
}

.select-list-item {
	padding: 5px 10px;
	font-size: 16px;
	color: #fff;
    user-select: none;
	line-height: 20px;
	cursor: pointer;
	display: flex;
}

.select-list-item:hover {
    background-color: rgba(0, 0, 0, 0.1);
}

.select-list-item.is-divide {
    height: 1px;
    padding: 0px;
    background-color: rgba(0, 0, 0, 0.1);
    margin: 10px 0px;
    pointer-events: none;
}

.select-list-item.is-active {
	font-weight: 400;
}

.select-list-item-icon {
	flex-shrink: 0;
	width: 32px;
	font-size: 16px;
}

.select-list-item-text {
	flex-grow: 1;
}

</style>
